'use client';
import Image from 'next/image';

interface Partner {
  id: string;
  title: string;
  image: string;
  category: 'events' | 'communities' | 'media';
  url?: string;
}

export default function PartnersSection() {
  const partners: Partner[] = [
    {
      id: '1',
      title: 'Global Games Show',
      image: '/images/ggs.webp',
      category: 'events',
      url:'https://www.globalgamesshow.com/',
    },
    {
      id: '2',
      title: 'Global Blockchain Show',
      image: '/images/gbs.webp',
      category: 'events',
      url:'https://www.globalblockchainshow.com/',
    },
  ];

  const mediaPartners: Partner[] = [
    {
      id: '1',
      title: 'All Conference Alert',
      image: '/images/all-conference-alert.webp',
      category: 'media',
      url: 'https://allconferencealert.net/',
    },
    {
      id: '2',
      title: 'Times of Game',
      image: '/images/timesofgame.webp',
      category: 'media',
      url: 'https://www.timesofgames.com/',
    },
    {
      id: '3',
      title: 'Coingape',
      image: '/images/coingape-new.webp',
      category: 'media',
      url: 'https://coingape.com/',
    },
    {
      id: '4',
      title: 'Coinpedia Fintech News',
      image: '/images/coinpediafintech.webp',
      category: 'media',
      url: 'https://coinpedia.org/',
    },
    {
      id: '5',
      title: 'Coinscapture',
      image: '/images/coinscapture.webp',
      category: 'media',
      url: 'https://coinscapture.com/',
    },
    {
      id: '6',
      title: 'Cryptonomist',
      image: '/images/cryptonomist-loro-white.webp',
      category: 'media',
      url: 'https://en.cryptonomist.ch/',
    },
    {
      id: '7',
      title: 'Cryptopolitan',
      image: '/images/dark-cp-logotype-transparent.webp',
      category: 'media',
      url: 'https://www.cryptopolitan.com/',
    },
    {
      id: '8',
      title: 'Embassy of Bitcoin',
      image: '/images/embassyofbitcoin.webp',
      category: 'media',
      url: 'https://www.embassyofbitcoin.com/',
    },
    {
      id: '9',
      title: 'Web3Wire',
      image: '/images/web3wire.webp',
      category: 'media',
      url: 'https://web3wire.org',
    },
    {
      id: '10',
      title: 'Brand PR',
      image: '/images/brandpr.webp',
      category: 'media',
      url: 'https://brandpr.io/',
    },
    {
      id: '11',
      title: 'Key Difference Wire',
      image: '/images/kd-wire.webp',
      category: 'media',
      url: 'https://keydifference.com/wire/',
    },
    {
      id: '12',
      title: 'Blockchain Media',
      image: '/images/blockchain-media.webp',
      category: 'media',
      url: 'https://blockchainmedia.id/',
    },
    {
      id: '13',
      title: 'CryptoJist',
      image: '/images/cryptojist.webp',
      category: 'media',
      url: 'https://cryptojist.com/',
    },
    {
      id: '14',
      title: 'CoinGabbar',
      image: '/images/coingabbar.webp',
      category: 'media',
      url: 'http://www.coingabbar.com/',
    },
    {
      id: '15',
      title: 'GTM Labs',
      image: '/images/gtm-labs.webp',
      category: 'media',
      url: 'https://gtmlabs.xyz/',
    },
    {
      id: '16',
      title: '3VerseTV',
      image: '/images/3versetv.webp',
      category: 'media',
      url: 'https://www.3versetv.com/',
    },
    {
      id: '17',
      title: 'Capitalbay News',
      image: '/images/capitalbay.webp',
      category: 'media',
      url: 'https://www.capitalbay.news/',
    },
    {
      id: '18',
      title: 'Coinnewsspan',
      image: '/images/coinnewsspan-new.svg',
      category: 'media',
      url: 'https://www.coinnewsspan.com/',
    },
    {
      id: '19',
      title: 'Times of Blockchain',
      image: '/images/tob.webp',
      category: 'media',
      url: 'https://www.timesofblockchain.com/',
    },
    {
      id: '20',
      title: 'Cryptomoonpress',
      image: '/images/cryptomoonpress.webp',
      category: 'media',
      url: 'https://cryptomoonpress.com/',
    },
    {
      id: '21',
      title: 'Cryptonewsz',
      image: '/images/cryptonewsz-logo.webp',
      category: 'media',
      url: 'https://www.cryptonewsz.com/',
    },
    {
      id: '22',
      title: 'NameCoinNews',
      image: '/images/namecoinnews.webp',
      category: 'media',
      url: 'https://www.namecoinnews.com/',
    },
    {
      id: '23',
      title: 'Times of AI',
      image: '/images/timesofai.webp',
      category: 'media',
      url: 'https://www.timesofai.com/',
    },
    {
      id: '24',
      title: 'AI Time Journal',
      image: '/images/aitimejournal.webp',
      category: 'media',
      url: 'https://aitimejournal.com',
    },
    {
      id: '25',
      title: 'Altwow',
      image: '/images/altwow.webp',
      category: 'media',
      url: 'https://altwow.com/',
    },
    {
      id: '26',
      title: 'CoinHohe',
      image: '/images/coinhohe.webp',
      category: 'media',
      url: 'https://coinhohe.com/',
    },
    {
      id: '27',
      title: 'CoinKimona',
      image: '/images/coinkimona.webp',
      category: 'media',
      url: 'https://coinkimona.com/',
    },
    {
      id: '28',
      title: 'Coinzoba',
      image: '/images/coinzoba.webp',
      category: 'media',
      url: 'https://coinzoba.com/',
    },
    {
      id: '29',
      title: 'Lixwe',
      image: '/images/lixwe.webp',
      category: 'media',
      url: 'https://lixwe.com/',
    },
    {
      id: '30',
      title: 'Prop Firm Lion',
      image: '/images/propfirm-lion.webp',
      category: 'media',
      url: 'https://propfirmlion.com/',
    },
    {
      id: '31',
      title: 'Startup News',
      image: '/images/startup.webp',
      category: 'media',
      url: 'https://startupnews.fyi/',
    },
    {
      id: '32',
      title: 'The Market Periodical',
      image: '/images/markert-periodical.webp',
      category: 'media',
      url: 'https://themarketperiodical.com/',
    },
    {
      id: '33',
      title: 'the-coin-republic',
      image: '/images/the-coin-republic-logo.webp',
      category: 'media',
      url: 'https://www.thecoinrepublic.com/',
    },
    {
      id: '34',
      title: 'Bitcoin World',
      image: '/images/bitcoinworld.webp',
      category: 'media',
      url: 'https://bitcoinworld.co.in/',
    },
    {
      id: '35',
      title: 'Blockopedia',
      image: '/images/theblockopedia-new.webp',
      category: 'media',
      url: 'https://theblockopedia.com/',
    },
    {
      id: '36',
      title: 'CoinFea',
      image: '/images/coinfea.webp',
      category: 'media',
      url: 'https://coinfea.com/',
    },
    {
      id: '37',
      title: 'Coinlyx',
      image: '/images/coinlyx.webp',
      category: 'media',
      url: 'https://coinlytx.com/',
    },
    {
      id: '38',
      title: 'CoinRoop',
      image: '/images/coinroop2.webp',
      category: 'media',
      url: 'https://coinroop.com/',
    },
    {
      id: '39',
      title: 'CoinTopper',
      image: '/images/cointopper.webp',
      category: 'media',
      url: 'https://cointopper.com/',
    },
    {
      id: '40',
      title: 'CoinWorldStory',
      image: '/images/coinworldstory.webp',
      category: 'media',
      url: 'https://coinworldstory.com/',
    },
    {
      id: '41',
      title: 'Crypto Browser',
      image: '/images/cryptobrowser.webp',
      category: 'media',
      url: 'https://cryptobrowser.io/',
    },
    {
      id: '42',
      title: 'Cryptoken Media',
      image: '/images/cryptotkonmedia.webp',
      category: 'media',
      url: 'https://cryptoken.media/',
    },
    {
      id: '43',
      title: 'EdArabia',
      image: '/images/edarabia-logo.webp',
      category: 'media',
      url: 'https://www.edarabia.com/',
    },
    {
      id: '44',
      title: 'International Institute of Blockchain',
      image: '/images/iib.webp',
      category: 'media',
      url: 'http://www.intlbm.com/',
    },
    
    {
      id: '46',
      title: 'Listing Help',
      image: '/images/listing-help.webp',
      category: 'media',
      url: 'https://listing.help/',
    },
    {
      id: '47',
      title: 'Tech Tokens',
      image: '/images/techtokens.webp',
      category: 'media',
      url: 'https://techtoken.in/',
    },
    {
      id: '48',
      title: 'Vitamin AI',
      image: '/images/vitaminai.webp',
      category: 'media',
      url: 'https://vitaminai.online/',
    },
    {
      id: '49',
      title: 'Voice of Crypto',
      image: '/images/voiceofcrytpo.webp',
      category: 'media',
      url: 'https://voiceofcrypto.online/',
    },
    {
      id: '50',
      title: 'ZEX PR Wire',
      image: '/images/zex-pr-wire.webp',
      category: 'media',
      url: 'https://zexprwire.com/',
    },
    {
      id: '51',
      title: 'Education Stake',
      image: '/images/education-stake-logo.webp',
      category: 'media',
      url: 'https://www.educationstake.com/en/media-library',
    },
    {
      id: '52',
      title: 'Functional Sourcing',
      image: '/images/function-sourcing-logo.webp',
      category: 'media',
      url: 'https://www.functionalsourcing.com/en/media-library',
    },
    {
      id: '53',
      title: 'Huidui',
      image: '/images/huidui.webp',
      category: 'media',
      url: 'https://www.huidu.cn/en',
    },
    {
      id: '54',
      title: 'Publicity Marketplace',
      image: '/images/publicity-marketplace.webp',
      category: 'media',
      url: 'https://www.publicitymarketplace.com/en/media-library',
    },
    {
      id: '55',
      title: 'MatchSDG',
      image: '/images/matchsdg.webp',
      category: 'media',
      url: 'https://www.matchsdg.com/en/media-library',
    },
    {
      id: '56',
      title: 'Smart Money Match',
      image: '/images/smartmoneymatch.webp',
      category: 'media',
      url: 'https://www.smartmoneymatch.com/help/media-partnerships',
    },
    {
      id: '57',
      title: 'Transport Stake',
      image: '/images/transport-stake-logo.webp',
      category: 'media',
      url: 'https://www.transportstake.com/',
    },

     {
      id: '58',
      title: 'bitcoin',
      image: '/images/bitcoin.webp',
      category: 'media',
      url: 'https://www.bitcoin.com/',
    },

    {
      id: '59',
      title: 'coinedition',
      image: '/images/coinedition.webp',
      category: 'media',
      url: 'https://coinedition.com/',
    },    
     {
      id: '60',
      title: 'cryptonews',
      image: '/images/cryptonews.webp',
      category: 'media',
      url: 'https://crypto.news/',
    },
 {
      id: '61',
      title: 'financialservices',
      image: '/images/financial.webp',
      category: 'media',
      url: 'https://www.financialservicesreview.com/',
    },

    {
      id: '62',
      title: 'icoholder',
      image: '/images/iconholder.webp',
      category: 'media',
      url: 'http://icoholder.com',
    },

     {
      id: '63',
      title: 'cioreview',
      image: '/images/cioreview-logo.webp',
      category: 'media',
      url: 'https://cioreview.com/',
    },
    
    {
      id: '64',
      title: 'CryptosNewss',
      image: '/images/cryptonewss.webp',
      category: 'media',
      url: 'https://cryptosnewss.com/',
    },

    {
      id: '65',
      title: 'AFFMaven',
      image: '/images/aff.webp',
      category: 'media',
      url: 'https://affmaven.com/',
    },

    {
      id: '66',
      title: 'IndNewsWire',
      image: '/images/indnewswire.webp',
      category: 'media',
      url: 'https://indnewswire.com/',
    },
    {
      id: '67',
      title: 'drromwhite',
      image: '/images/drromwhite.webp',
      category: 'media',
      url: 'https://droomdroom.com/',
    },

    {
      id: '68',
      title: 'web3africawhite',
      image: '/images/web3africawhite.webp',
      category: 'media',
      url: 'https://web3africa.tech/',
    },

    {
      id: '69',
      title: 'blockchainreporter',
      image: '/images/blockchainreporter.webp',
      category: 'media',
      url: 'https://blockchainreporter.net/',
    },
    {
      id: '70',
      title: 'dubai-global-news',
      image: '/images/dubai-global-news.webp',
      category: 'media',
      url: 'https://www.dubaiglobalnews.com/',
    },
    {
      id: '71',
      title: 'coinpedia-logo',
      image: '/images/coinpedia-logo.svg',
      category: 'media',
      url: 'https://coinpedia.org/',
    },

    {
      id: '72',
      image: '/images/game-3s-white.webp',
      title: 'game-3s-white',
      category: 'media',
      url: 'https://www.games.gg/',
  },

  {
    id:'73',
    image: '/images/tredu-logopr.svg',
    title: 'tredu-logo',
    category:'media',
    url: 'https://www.tredu.com/',
  },

  {
    id:'74',
    image: '/images/blockchain-texno-white.webp',
    title: 'blockchain-texno',
    category:'media',
    url: 'https://www.blockchaintexno.uz/',
  },

  {
    id:'75',
    image: '/images/invest24-logo.webp',
    title: 'invest24-logo',
    category:'media',
    url: 'https://www.invest24.uz/',
  },

    
  ];

  return (
    <>
      {/* Partners & Collaborators Section */}
      <section data-component-id="src/app/PartnersSection.tsx:570:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="570" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20py-%5B34px%5D%20sm%3Apy-%5B51px%5D%20md%3Apy-%5B60px%5D%22%7D"
        id="partners"
        className="w-full py-[34px] sm:py-[51px] md:py-[60px]"
      >
        <div data-component-id="src/app/PartnersSection.tsx:574:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="574" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-0%22%7D" className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-0">
          <div data-component-id="src/app/PartnersSection.tsx:575:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="575" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B25px%5D%20sm%3Agap-%5B37px%5D%20md%3Agap-%5B44px%5D%20lg%3Agap-%5B50px%5D%20justify-start%20items-center%22%7D" className="flex flex-col gap-[25px] sm:gap-[37px] md:gap-[44px] lg:gap-[50px] justify-start items-center">
            <h2 data-component-id="src/app/PartnersSection.tsx:576:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="576" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B30px%5D%20md%3Atext-%5B34px%5D%20lg%3Atext-%5B38px%5D%20font-bold%20leading-tight%20text-center%20text-text-primary%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D"
              className="text-[24px] sm:text-[30px] md:text-[34px] lg:text-[38px] font-bold leading-tight text-center text-text-primary"
              style={{ fontFamily: 'Montserrat' }}
            >
              Past Partners & Collaborators
            </h2>

            <div data-component-id="src/app/PartnersSection.tsx:583:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="583" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20gap-%5B20px%5D%20sm%3Agap-%5B24px%5D%20md%3Agap-%5B28px%5D%20w-full%20max-w-%5B500px%5D%22%7D" className="grid grid-cols-2 gap-[20px] sm:gap-[24px] md:gap-[28px] w-full max-w-[500px]">
              {partners.map((partner) => (
                <div data-component-id="src/app/PartnersSection.tsx:585:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="585" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B10px%5D%20sm%3Agap-%5B12px%5D%20md%3Agap-%5B14px%5D%20justify-start%20items-center%20w-full%22%7D"
                  key={partner.id}
                  className="flex flex-col gap-[10px] sm:gap-[12px] md:gap-[14px] justify-start items-center w-full"
                >
                  <div data-component-id="src/app/PartnersSection.tsx:589:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="589" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-30%22%7D" className="w-30">
                    <a data-component-id="src/app/PartnersSection.tsx:590:20" data-component-path="src/app/PartnersSection.tsx" data-component-line="590" data-component-file="PartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22block%20relative%20w-%5B150px%5D%20h-%5B80px%5D%22%7D"
                      href={partner.url}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="block relative w-[150px] h-[80px]"
                    >
                    <Image data-component-id="src/app/PartnersSection.tsx:596:20" data-component-path="src/app/PartnersSection.tsx" data-component-line="596" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-cover%20rounded-lg%20h-%5B70px%5D%20%22%7D"
                      src={partner.image}
                      alt={`Logo of ${partner.title} – Event Partner`}
                      width={150}
                      height={80}
                      unoptimized
                      className="object-cover rounded-lg h-[70px] "
                    />
                    </a>
                  </div>
                  <h3 data-component-id="src/app/PartnersSection.tsx:606:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="606" data-component-file="PartnersSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B14px%5D%20sm%3Atext-%5B16px%5D%20md%3Atext-%5B17px%5D%20lg%3Atext-%5B18px%5D%20font-semibold%20text-center%20text-text-primary%22%7D"
                    className="text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] font-semibold text-center text-text-primary"
                    style={{ fontFamily: 'Inter' }}
                  >
                  </h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Media Partners Section */}
      <section data-component-id="src/app/PartnersSection.tsx:619:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="619" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22media-partners%22%2C%22className%22%3A%22w-full%20pb-%5B40px%5D%20md%3Apb-%5B80px%5D%22%7D" id="media-partners" className="w-full pb-[40px] md:pb-[80px]">
        <div data-component-id="src/app/PartnersSection.tsx:620:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="620" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-0%22%7D" className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-0">
          <div data-component-id="src/app/PartnersSection.tsx:621:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="621" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B25px%5D%20sm%3Agap-%5B37px%5D%20md%3Agap-%5B44px%5D%20lg%3Agap-%5B50px%5D%20justify-start%20items-center%22%7D" className="flex flex-col gap-[25px] sm:gap-[37px] md:gap-[44px] lg:gap-[50px] justify-start items-center">
            <h2 data-component-id="src/app/PartnersSection.tsx:622:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="622" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B30px%5D%20md%3Atext-%5B34px%5D%20lg%3Atext-%5B38px%5D%20font-bold%20text-center%20text-text-primary%22%2C%22textContent%22%3A%22Past%20Media%20Partners%22%7D"
              className="text-[24px] sm:text-[30px] md:text-[34px] lg:text-[38px] font-bold text-center text-text-primary"
              style={{ fontFamily: 'Montserrat' }}
            >
              Past Media Partners
            </h2>

            {/* Box container */}
            <div data-component-id="src/app/PartnersSection.tsx:630:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="630" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1200px%5D%20rounded-lg%22%7D" className="w-full max-w-[1200px] rounded-lg">
              <div data-component-id="src/app/PartnersSection.tsx:631:14" data-component-path="src/app/PartnersSection.tsx" data-component-line="631" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20lg%3Agrid-cols-5%20gap-x-%5B20px%5D%20gap-y-%5B16px%5D%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-[20px] gap-y-[16px]">
                {mediaPartners.map((partner) => (
                  <div data-component-id="src/app/PartnersSection.tsx:633:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="633" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-black%20rounded-%5B10px%5D%20flex%20justify-center%20items-center%20w-full%20h-full%22%7D"
                    key={partner.id}
                    className="bg-black rounded-[10px] flex justify-center items-center w-full h-full"
                  >
                    <a data-component-id="src/app/PartnersSection.tsx:637:20" data-component-path="src/app/PartnersSection.tsx" data-component-line="637" data-component-file="PartnersSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22block%20relative%20w-%5B150px%5D%20h-%5B80px%5D%22%7D"
                      href={partner.url}
                      target="_blank"
                      rel={
                        partner.url === "https://www.cryptonewsz.com/"
                          ? "noopener noreferrer"
                          : "noopener noreferrer nofollow"
                      }
                      className="block relative w-[150px] h-[80px]"
                    >
                      <Image data-component-id="src/app/PartnersSection.tsx:647:22" data-component-path="src/app/PartnersSection.tsx" data-component-line="647" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-%5B160px%5D%20h-%5B80px%5D%22%7D"
                        src={partner.image}
                        alt={`Logo of ${partner.title} – Media Partner`}
                        width={150}
                        height={80}
                        unoptimized
                        className="object-contain w-[160px] h-[80px]"
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
